module.exports = __webpack_public_path__ + "static/media/bg-waves.5ae05e65.png";